module.exports = __webpack_public_path__ + "img/Mieterstrom.ac9da110.png";